module.exports = __webpack_public_path__ + "img/txt-create.ac3a4d10.png";